$(document).ready(function () {
    if ($('.block__image-with-text-block-heading').find('span').length) {
        $('.block__image-with-text-block-heading').slick({
            draggable: false,
            infinite: true,
            autoplay: true,
            arrows: false,
            autoplaySpeed: 1500,
            slidesToShow: 1,
            vertical: true
        });
    }
 })